import styled from 'styled-components';

import { RenderOverlayContentWrapper } from '@components/ui/search/SearchBarInput/SearchBarInputStyle';

export const Container = styled.div`
  min-width: 150px;
  width: 100%;
  height: 100%;
  position: relative;

  @media (max-width: ${({ theme }) => theme.breakPoint.LARGE_1X}) {
    max-width: 100% !important;
    width: 100% !important;
  }

  @media (min-width: ${({ theme }) => theme.breakPoint.LARGE_1X}) {
    border-bottom: 0px solid #000;
  }
`;

export const SelectedCompWrapper = styled.div<{ isError?: boolean }>`
  position: relative;
  display: flex;
  gap: 12px;
  box-shadow: ${({ isError }) =>
    isError ? 'inset 0 0 0 3px #d95c5c' : 'none'};
`;

export const Label = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.grey1100};
`;

export const HotelCalendarOverlayContentWrapper = styled(
  RenderOverlayContentWrapper
)`
  @media (min-width: ${({ theme }) => theme.breakPoint.LARGE_1X}) {
    .DayPicker > div > div:first-child {
      margin-inline: auto;
      position: relative;
      left: 1px;
    }
  }
`;
